<template>
  <div
    class="common-input fb fb-main-between fb-cross-center"
    @click="handlerClick"
  >
    <span
      class="common-input-label font-34"
      :class="{ required: required }"
      :style="`width:${labelWidth}px;`"
      >{{ label }}</span
    >
    <div class="fb fb-cross-center">
      <input
        :class="[
          'item-flex-1',
          color ? 'c-191F25-28' : '',
          leftOrRight ? 'right' : 'left',
          computedIsAddIos ? 'add-padding-ios' : ''
        ]"
        :maxlength="maxlength"
        type="text"
        v-model="value"
        :placeholder="placeholder"
        @focus="focus"
        @blur="blur"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'commonSelectInputBox',
  components: {},
  props: {
    label: String,
    value: '',
    required: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    labelWidth: {
      type: Number,
      default: 70
    },
    color: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: [Number, String],
      default: 10000
    }
  },
  data() {
    return {
      date: '',
      leftOrRight: true
    }
  },
  computed: {
    computedIsAddIos() {
      let _isIphone = window.navigator.userAgent.includes('iPhone')
      return _isIphone
    }
  },
  watch: {
    value(v) {
      this.$emit('inputValue', v)
    }
  },
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {
    this.init()
  },
  beforeUpdate() {},
  updated() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    init() {},
    handlerClick(e) {
      this.$emit('click', e)
    },
    focus() {},
    blur() {
      this.leftOrRight = true
      this.$emit('blur')
    }
  },
  filters: {}
}
</script>

<style lang="scss" scoped>
.common-input {
  width: 100%;
  height: 56px;
  line-height: 56px;
  // border-bottom: 1px solid rgba(#191f25, 0.12);

  > span {
    margin-right: 12px;
    display: inline-block;
  }
  > div {
    height: 100%;
    width: calc(100% - 100px);
  }
  input {
    // padding-right: 20px;
    width: 100%;
    // 谷歌浏览器输入框placeholder颜色设置
    &::-webkit-input-placeholder {
      color: rgba(#191f25, 0.28);
    }
    // 火狐浏览器输入框placeholder颜色设置
    &::-moz-placeholder {
      color: rgba(#191f25, 0.28);
    }
    // IE浏览器输入框placeholder颜色设置
    &::-ms-input-placeholder {
      color: rgba(#191f25, 0.28);
    }
  }
}
.left {
  text-align: -webkit-left;
  text-align: left;
}

.right {
  text-align: -webkit-right;
  text-align: right;
}
.add-padding-ios {
  padding-bottom: 3px;
}
</style>
